import script from "./ActionsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsButton.vue?vue&type=script&setup=true&lang=js"

import "./ActionsButton.vue?vue&type=style&index=0&id=2c2ec471&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2ec471"]])

export default __exports__